export default __webpack_public_path__ + "static/media/minicard11.dfc74ac3.jpg";